import {
  base_colorAction,
  base_colorContentBorder,
  base_colorRaisedSurface,
  grey100,
  tag_colorTagSevereText,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const tableCard = css`
  display: flex;
  flex-direction: column;
`

// Shared height for the toolbar's saved-views trigger and search input so they
// line up. Scoped to this toolbar — the shared UtilityToolbarDropdown (38px
// trigger) and medium TextInput (52px) keep their defaults everywhere else.
const TOOLBAR_CONTROL_HEIGHT = '40px'

export const toolbar = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};

  & .UtilityToolbarDropdown.button {
    height: ${TOOLBAR_CONTROL_HEIGHT};
    min-height: ${TOOLBAR_CONTROL_HEIGHT};
  }
`

export const search = css`
  flex: 1;

  /* Match the search input to the saved-views trigger height (see toolbar). */
  & .textbox-container.medium {
    height: ${TOOLBAR_CONTROL_HEIGHT};
  }
`

/*
  The MaskedCardNumber component handles the **** / digit / SR phrase
  triplet; this style just sets typography on its wrapper. The trailing
  space inside the **** literal provides separation, so no gap is
  needed.
*/
export const cardNumber = css`
  font-family: ${font_family_weight_regular};
  ${font_md};
  color: ${text_colorTextPrimary};
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
  white-space: nowrap;
`

export const actionTrigger = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  color: ${base_colorAction};

  &:hover {
    background-color: ${grey100};
  }

  &:focus-visible {
    outline: 2px solid ${text_colorTextPrimary};
    outline-offset: 2px;
  }

  /* Mirrors the Button disabled convention (opacity + not-allowed). */
  &:disabled {
    color: ${text_colorTextSecondary};
    opacity: 50%;
    cursor: not-allowed;

    &:hover {
      background-color: transparent;
    }
  }
`

/*
  Positioning (fixed, from the trigger's rect) is applied inline by
  CardActionsMenu, which portals the menu to <body> so the DataGrid cell's
  overflow: hidden can't clip it.
*/
export const actionMenu = css`
  display: flex;
  flex-direction: column;
  padding: ${spacing(1)} 0;
  background-color: ${base_colorRaisedSurface};
  border: 1px solid ${base_colorContentBorder};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`

export const actionMenuItem = css`
  appearance: none;
  background: transparent;
  border: none;
  text-align: left;
  padding: ${spacing(2)} ${spacing(3)};
  font-family: ${font_family_weight_medium};
  ${font_md};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: ${grey100};
  }
`

export const actionMenuItemBranded = css`
  color: ${base_colorAction};
`

export const actionMenuItemSevere = css`
  color: ${tag_colorTagSevereText};
`

export const gridWrap = css`
  width: 100%;
`

export const overlay = css`
  ${font_md};
  color: ${text_colorTextSecondary};
  text-align: center;
  padding: ${spacing(8)} ${spacing(4)};
`

export const saveViewForm = css`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${spacing(4)};
  padding: ${spacing(4)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

export const truncationNotice = css`
  ${font_sm};
  color: ${text_colorTextSecondary};
  padding: ${spacing(2)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};
`
